import moment from 'moment';
import { GetterTree } from 'vuex';
import { RootState } from '@/store/store';
import { IVideoRecorderState } from '@/video/recorder/store/video-recorder.types';
import { EVideoRecorderGetter } from '@/video/recorder/store/video-recorder.constants';

export const getters: GetterTree<IVideoRecorderState, RootState> = {
  [EVideoRecorderGetter.FormattedTime]: (state: IVideoRecorderState): string => {
    return moment.utc(state.elapsedSeconds * 1000).format('mm:ss');
  },
};
